import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) target.appendChild(script);
    }
    w.fbq('init', '1505055387754753');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-gold/30 selection:text-navy" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1505055387754753&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <Hook data-id="element-4" />
      <Problem data-id="element-5" />
      <UniqueMechanism data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <WhoIsItFor data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <Proof data-id="element-10" />
      <FAQ data-id="element-11" />
      <Pricing data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}